export const slugify = (str) => str
  .toLowerCase()
  .trim()
  .replace(/[^\w\s-]/g, '')
  .replace(/[\s_-]+/g, '-')
  .replace(/^-+|-+$/g, '');

// Up to two initials to stand in for a missing logo: "Bureau X" gives "BX". A
// bracketed suffix such as "[Test]" is not part of the name people recognise.
export const getInitials = (name) => (name || '')
  .replace(/\[[^\]]*\]|\([^)]*\)/g, ' ')
  .split(/\s+/)
  .map((word) => word.match(/[\p{L}\p{N}]/u)?.[0])
  .filter(Boolean)
  .slice(0, 2)
  .join('')
  .toUpperCase();
